import { apiShareLog } from '@/request/api';
import { useRoute } from 'vue-router';

export default () => {
    const route = useRoute();
    const share = route.query.share || false;

    (() => {
        if (!share) return;
        const params = {}
        if (route.query.articleId) {
            params.articleId = route.query.articleId
        }
        apiShareLog(params);
    })()
}